import { v4 as i } from "uuid";
import { Adapter as o } from "../../../../../adapter.js";
import { ShopSessionCheckoutFieldModel as r } from "./checkoutField.model.js";
class c extends o {
  adapt(e) {
    return new r({
      id: (e == null ? void 0 : e.id) ?? i(),
      icon: e.icon,
      label: e.label,
      description: e.description,
      options: e.options,
      type: e.type,
      status: e.status,
      required: e.required,
      services: e.services
    });
  }
  serialize(e) {
  }
}
export {
  c as ShopSessionCheckoutFieldAdapter
};
//# sourceMappingURL=checkoutField.adapter.js.map
